import { useQuery } from "@tanstack/react-query";
import { useGetAccountInfo, useGetLoginInfo } from "@multiversx/sdk-dapp/hooks";
import { aiNexusApiService } from "../services/ai-nexus-api.service";

export const useWalletVerification = () => {
  const { tokenLogin } = useGetLoginInfo();

  return useQuery({
    queryKey: ["wallet-verification", tokenLogin?.nativeAuthToken],
    queryFn: async () => {
      if (!tokenLogin?.nativeAuthToken) {
        return { valid: false, message: "No wallet connected" };
      }

      try {
        const result = await aiNexusApiService.verifyWallet({
          nativeToken: tokenLogin?.nativeAuthToken,
        });
        return result;
      } catch (error) {
        console.error("Wallet verification failed:", error);
        return { valid: false, message: "Verification failed" };
      }
    },
    enabled: !!tokenLogin?.nativeAuthToken,
    staleTime: 2 * 60 * 1000, // 2 minutes
    retry: 1,
  });
};
